// extracted by mini-css-extract-plugin
export default {"main":"styles_main__HEzLo","container":"styles_container__Z8yiY"};